import { Outlet, redirect, useLocation, useNavigate } from "@vixi/router";
import { LangKey, useTranslation } from "@vixi/localization";
import { useMemo } from "react";
import { FilterTabs, FilterTab, useGoBack, PageMainContent } from "@vixi/ui";
import { RouteOptionsById, RouterIds } from "@vixi/router";

const routeId = "/_app/settings" satisfies RouterIds;

export const SettingsRouteOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
  beforeLoad: async ({ matches }) => {
    const pageMatch = matches.findIndex((match) => match.fullPath === "/settings");

    if (pageMatch === matches.length - 1) {
      throw redirect({
        to: "/settings/account-settings",
      });
    }
  },
};

type SETTINGS_TAB = "account-settings" | "subscription";

const settings_tabs: FilterTab<LangKey, SETTINGS_TAB>[] = [
  {
    label: "Settings.AccountSettings.TabName",
    value: "account-settings",
  },
  {
    label: "Settings.Subscription.TabName",
    value: "subscription",
  },
];

function RouteComponent() {
  useGoBack(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = useMemo(() => {
    return (location.pathname.split("/").pop() ?? "account-settings") as SETTINGS_TAB;
  }, [location]);

  const onTabChange = (value: SETTINGS_TAB) => {
    navigate({
      to: `/settings/${value}`,
    });
  };

  return (
    <PageMainContent psY="medium">
      <div className="mx-auto">
        <FilterTabs
          value={currentTab}
          onChange={onTabChange}
          tabs={settings_tabs.map((tab) => ({ ...tab, label: t(tab.label) }))}
        />
      </div>

      <div className="mt-8 flex-1">
        <Outlet />
      </div>
    </PageMainContent>
  );
}
